import classnames from 'classnames';
import React from 'react';

import './styles.less';

// Fast Action Button renders as a circular white button with a shadow by default,
// optionally showing a label underneath
// Example usage:
// <FabButton
//   onClick={ () => {} }
//   renderButtonChildren={ () => <ActionDot position={ TOP_RIGHT } /> }
//   icon="settings-rp">
//   Settings
// </FabButton>
class FabButton extends React.Component {
  static defaultProps = {
    className: null,
    renderButtonChildren: () => null,
    icon: '',
    onClick: () => {},
    onHover: () => {},
    onBlur: () => {},
  };

  render() {
    const {
      className,
      icon,
      onHover,
      onBlur,
      renderButtonChildren,
      children,
      disabled,
    } = this.props;

    const classNames = classnames('fab-button', className, {
      'with-label': children,
      'fab-button--disabled': disabled,
    });

    return (
      <div
        className={classNames}
        onClick={this.onFabClick}
        onMouseEnter={onHover}
        onMouseLeave={onBlur}
      >
        <div className={`fab-button-button fab-button-icon-${icon}`}>
          {renderButtonChildren()}
        </div>
        {children}
      </div>
    );
  }

  onFabClick = () => {
    if (this.props.disabled) {
      return;
    }

    this.props.onClick();
  };
}

export default FabButton;
